export default __webpack_public_path__ + "static/media/Clan Bound Straps of the Tribes.b64a1e59.jpg";